import { Request } from '../request';

export const getStripeSession = (linkUuid: string, planId: number) =>
    Request.post({ url: '/schedule-server/openapi/sales/contract/link/checkout/session/generate',
        params: {
            linkUuid,
            planId,
        } });

export const getStripePaymentInfo = () => Request.get({ url: '/schedule-server/provider/getStripePaymentInfo' });

/** Stripe unified checkout (e.g. eFax subscription). */
export const stripeUnifiedPay = (params: import('types/eFax').TStripeUnifiedPayReq) =>
    Request.post<import('types/eFax').TStripeUnifiedPayReq>({
        url: '/schedule-server/provider/channel/stripe/unifiedPay',
        params,
    });
